<div class="d-flex flex-column py-10 text-center position-relative">
  <div class=" d-flex justify-content-center">
    <ng-lottie class="top-0 z-index-3 w-1000px" [options]="options" ></ng-lottie>
  </div>

  <a [href]="'/'" class="link-primary fs-1 mt-4 fw-bold btn"> Back To Home </a>
</div>
